import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { getApiErrorMessage } from "../../helpers/aws_api_helper";
import {
  getSsoConfig,
  postSsoConfig,
  putSsoConfig,
} from "../../helpers/auth_aws_helper";
import {
  fetchSsoConfigFailure,
  fetchSsoConfigSuccess,
  saveSsoConfigFailure,
  saveSsoConfigSuccess,
} from "./ssoConfigSlice";

function readBody(response) {
  if (!response) return null;
  if (response.data !== undefined && response.status !== undefined) {
    return response.data;
  }
  return response;
}

function* fetchSsoConfig({ payload }) {
  try {
    const response = yield call(getSsoConfig, payload.providerType);
    if (response && response.status === 200) {
      yield put(fetchSsoConfigSuccess(readBody(response)));
    } else {
      yield put(fetchSsoConfigFailure(getApiErrorMessage(response)));
    }
  } catch (error) {
    yield put(fetchSsoConfigFailure(getApiErrorMessage(error.response || error)));
  }
}

function* saveSsoConfig({ payload }) {
  try {
    const request = payload.method === "PUT" ? putSsoConfig : postSsoConfig;
    const response = yield call(request, payload.body);
    if (response && response.status === 200) {
      yield put(saveSsoConfigSuccess(readBody(response)));
    } else {
      yield put(
        saveSsoConfigFailure({
          status: response?.status,
          message: getApiErrorMessage(response),
        })
      );
    }
  } catch (error) {
    yield put(
      saveSsoConfigFailure({
        status: error.response?.status,
        message: getApiErrorMessage(error.response || error),
      })
    );
  }
}

function* watchSsoConfig() {
  yield takeLatest("ssoConfig/fetchSsoConfig", fetchSsoConfig);
  yield takeLatest("ssoConfig/saveSsoConfig", saveSsoConfig);
}

export default function* ssoConfigSaga() {
  yield all([fork(watchSsoConfig)]);
}
